import classNames from '@/utils/classNames';
import type { CSSProperties, ReactNode } from 'react';
import type { FCl } from 'react-fc';
import styles from './Badge.module.css';

export const Badge: FCl<IProps> = ({ className, link, text, noTitle, icon, colorVar = 'default' }) => {
    const badgeProps = {
        title: noTitle ? undefined : text, // for when the label is truncated
        className: classNames('cds-t-label-xsmall cds-t-label-xsmall--bold', styles.badge, className),
        style: {
            '--_Tag-color-background': `var(--color-Badge-${colorVar}-background)`,
            '--_Tag-color-text': `var(--color-Badge-${colorVar}-text)`,
        } as CSSProperties,
    };

    const content = (
        <>
            {icon && <span className={styles.icon}>{icon}</span>}
            <span className={styles.text}>{text}</span>
        </>
    );

    if (link) {
        return (
            <a href={link} {...badgeProps}>
                {content}
            </a>
        );
    }

    return <span {...badgeProps}>{content}</span>;
};

export type allowedColorVars =
    | 'blue'
    | 'green'
    | 'red'
    | 'purple'
    | 'teal'
    | 'pink'
    | 'yellow'
    | 'grey'
    | 'default'
    | 'content';

interface IProps {
    colorVar?: allowedColorVars;
    text?: string;
    icon?: ReactNode;
    link?: string;
    noTitle?: boolean;
}
